import { usePage } from "@inertiajs/react"

import type { CurrentUser } from "@/types"

export type Permissions = CurrentUser["permissions"]

/** What the signed-in user may do (Users::Permissions). Pages hide what the server would refuse. */
export function usePermissions(): Permissions {
  const { auth } = usePage().props
  if (!auth) throw new Error("usePermissions needs a signed-in user")

  return auth.user.permissions
}
